module.exports = __webpack_public_path__ + "6b80be17a71c7d80cf3495157202ee52.gif";